import html2canvas from 'html2canvas';

/**
 * PNG export of a rendered template (B3-SocialMedia). The node is drawn at
 * the scale that gives the format's real width, then fitted onto a canvas of
 * exactly width × height so the file has the platform's dimensions.
 */
export interface PngFormat {
  width: number;
  height: number;
  filename: string;
}

export async function renderNodeToPng(node: HTMLElement, { width, height }: Omit<PngFormat, 'filename'>): Promise<Blob> {
  const shown = node.getBoundingClientRect().width || node.offsetWidth || width;
  const drawn = await html2canvas(node, { scale: width / shown, useCORS: true, backgroundColor: '#0a0a0a', logging: false });
  const out = document.createElement('canvas');
  out.width = width;
  out.height = height;
  const ctx = out.getContext('2d');
  if (!ctx) throw new Error('PNG_EXPORT_FAILED');
  ctx.drawImage(drawn, 0, 0, width, height);
  const blob = await new Promise<Blob | null>((resolve) => out.toBlob(resolve, 'image/png'));
  if (!blob) throw new Error('PNG_EXPORT_FAILED');
  return blob;
}

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export async function exportNodeAsPng(node: HTMLElement, format: PngFormat): Promise<void> {
  const blob = await renderNodeToPng(node, format);
  downloadBlob(format.filename.endsWith('.png') ? format.filename : `${format.filename}.png`, blob);
}
